import { Alert } from '@insight-health-ai/roseate/components';
import type { FormBlock } from '../types';

type NoticeBlock = FormBlock & {
  message: string;
  description?: string;
  appearance?: 'info' | 'success' | 'warning';
  icon?: boolean;
  closable?: boolean;
};

export function Notice({ block }: { block: NoticeBlock }) {
  return (
    <Alert
      appearance={block.appearance ?? 'info'}
      message={block.message}
      description={block.description}
      icon={block.icon ?? true}
      closable={block.closable}
      className={block.className}
    />
  );
}
